

import {computed, onMounted, ref} from 'vue'
import {useToast} from "primevue/usetoast";

import BookRepository from '@/services/BookRepository'
import BookResult from '@/models/bookresult.models'
import {useStore} from "vuex";
import Book from '@/models/book.models';
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import {FilterMatchMode} from "primevue/api";
import KeyValue from "@/utils/keyvalue";
import takeColor from '@/utils/color';
import regis from "@/utils/format";
import {Count} from "@/models/count.models";

export default {
  setup() {
    const date = ref(new Date())
    const books = ref([] as BookResult[]);
    const booksDefault = ref([] as BookResult[]);
    const toast = useToast();
    const isLoading = ref(false);
    const store = useStore();
    const bookSelect = ref({} as Book);
    const edit= ref(false);
    const teams = ref({} as Team[]);
    const selectTeam = ref("");
    const master = ref(false);
    const displayPopup = ref(false);
    const countInYear = ref(false);
    const counts = ref({} as Count[]);
    const time = ref(new Date());

    const selectedGroup = ref([] as KeyValue[]);

    BookRepository.countBooks(time.value)
            .then(response => {
              counts.value = response.data;
            })
            .catch(() => {
              toast.add({
                severity: 'error',
                summary: 'Thất bại',
                detail: 'Không thể tải danh sách lịch đăng ký khám bệnh.',
                life: 1000
              });
            });

    const totalDataCount = computed(() => {
      const data = counts.value;
      return {
        labels: data.map(x => x.name),
        datasets: [
          {
            label: 'Số lượt đăng ký khám bệnh',
            data: data.map(x => x.count),
            backgroundColor: '#42A5F5'
          }
        ]
      }
    });

    const groups = (() => {
      displayPopup.value = true;
    });

    const countYear = (() => {
      countInYear.value = true;
    });

    const totalData = computed(() => {
      const data = selectedGroup.value;
      return {
        labels: data.map(x => x.key),
        datasets: [
          {
            data: data.map(x => x.value),
            backgroundColor: takeColor(data.length)
          }
        ]
      }
    });

    const chartOptions = {
      tooltips: {
        mode: 'index',
        callbacks: {
          label(tooltipItem, data) {
            return `${data.labels[tooltipItem.index]}: ${regis(data.datasets[0].data[tooltipItem.index])}`;
          }
        }
      }
    };

    if(store.state.permission == 'mster'){
      master.value = true;
    }

    TeamRepository.getTeams()
            .then((response) => {
              teams.value = response.data;
            })
            .catch();

    const select = () =>{
      if(selectTeam.value == null)
        books.value = booksDefault.value;
      else
        books.value = booksDefault.value.filter(x => x.team == selectTeam.value);
    }

    const loadBook = () => {
      isLoading.value = true;
      TeamRepository.getTeams()
              .then((response) => {
                teams.value = response.data;
                BookRepository.getBooksByMonth(date.value, store.state.team, store.state.permission, "all")
                        .then(response => {
                          books.value = response.data;
                          books.value.forEach(x => {
                            teams.value.forEach(y => {
                              if(y.code == x.team) x.team = y.name;
                            });
                          });
                          const group = ref([] as KeyValue[]);
                          teams.value.forEach(x => {
                            const count = books.value.filter(y => y.team == x.name);
                            if(count.length > 0) group.value.push({'key': x.name, 'value': count.length});
                          });
                          selectedGroup.value = group.value;
                          booksDefault.value = books.value;
                        })
                        .catch(() => {
                          toast.add({
                            severity: 'error',
                            summary: 'Thất bại',
                            detail: 'Không thể tải danh sách lịch đặt chổ.',
                            life: 1000
                          });
                        })
                        .finally(() => {
                          isLoading.value = false;
                        });
              })
              .catch();
    }

    const editBook = (id: number) => {
        BookRepository.getById(id)
            .then(response => {
                bookSelect.value = response.data;
                edit.value = true;
            })
            .catch(() => {
                toast.add({
                    severity: 'error',
                    summary: 'Thất bại',
                    detail: 'Không thể tải danh sách lịch đăng ký khám bệnh.',
                    life: 1000
                });
            })
            .finally(() => {
                isLoading.value = false;
            });
    }
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    onMounted(loadBook);

    return {
      date,
      loadBook,
      books,
      isLoading,
      bookSelect,
      editBook,
      edit,
      select,
      teams,
      selectTeam,
      filters,
      clearFilter,
      initFilters,
      master,
       groups,
      totalData,
      displayPopup,
      selectedGroup,
      chartOptions,
      totalDataCount,
      countInYear,
      countYear,
    }
  }

}
